import React from 'react';
import { Table } from 'semantic-ui-react';
import CompactTableHeader from '@/components/table/CompactTableHeader';
import TableErrorRow from '@/components/table/TableErrorRow';
import { states } from '@/constants/lifecycle';

const MemberPermissionsTableHeader = ({
  readStatus,
  error,
  onErrorDismiss,
  children,
}) => (
  <Table.Header fullWidth>
    <CompactTableHeader
      isLoading={readStatus === states.PENDING}
      numberOfColumns={5}
      className="aridhia-member-permissions-header"
      headerId="users.with.access"
    />
    <TableErrorRow
      error={error}
      onErrorDismiss={onErrorDismiss}
      numberOfColumns={5}
    />
    { children }
  </Table.Header>
);

export default MemberPermissionsTableHeader;
